<template>
  <div class="pt-3 pb-5 text-white text-center main-hero">
    <div class="container">
        <h1 class="mt-5 pb-3 display-6">Discover benefits with SuperGold</h1>
        <h2 class="mb-3 fw-light fs-4">
          SuperGold helps you stretch your money further with instant discounts and special offers.
        </h2>
        <h2 class="mb-5 fw-light fs-4">
          Explore offers locally or nationwide.
        </h2>

        <ais-search-box>
          <template v-slot="{ currentRefinement, refine }">
            <div class="row g-2">
              <div class="col">
                <div class="input-group border-0">
                  <div class="input-group-text">
                    <i class="bi bi-search"></i>
                  </div>
                  <input
                    @keyup.enter="refine($refs.searchInput.value)"
                    class="form-control border-0"
                    type="search"
                    ref="searchInput"
                    placeholder="Search for gardeners, electronics etc"
                    :value="currentRefinement"
                    >
                <button
                  data-bs-toggle="modal"
                  data-bs-target="#locationModal"
                  class="btn bg-white border-start text-primary d-none d-md-block">
                  <span class="bi bi-geo-alt-fill"></span>
                  {{ location }}
                </button>
                </div>
              </div>

              <div class="col-12 d-block d-md-none">
                <button
                  data-bs-toggle="modal"
                  data-bs-target="#locationModal"
                  class="btn bg-white text-primary w-100">
                  <span class="bi bi-geo-alt-fill"></span>
                  {{ location }}
                </button>
              </div>

              <div class="col-lg-2 col-md-4">
                <button
                  @click="refine($refs.searchInput.value)"
                  class="btn bg-white text-primary w-100">
                  Search offers
                </button>
              </div>
            </div>
          </template>
        </ais-search-box>
      </div>
    </div>
</template>

<script>
import { AisSearchBox } from 'vue-instantsearch/vue3/es';

export default {
  name: 'SearchBox',
  components: {
    AisSearchBox,
  },
  data() {
    return {
      location: this.getCurrentLocation(),
    };
  },
  methods: {
    getCurrentLocation() {
      const params = new URLSearchParams(window.location.search);
      return params.get('menu[district]') || params.get('menu[region]') || 'All of New Zealand';
    },
  },
};
</script>
